import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { Lock } from '@material-ui/icons/';
import SystemNavigation from 'src/web/components/SystemNavigation/index';
import { useStyles } from './styles';

export default function UnauthorizedPage() {
  const classes = useStyles();

  return (
    <>
      <Box bgcolor="warning.light" className={classes.icon_box}>
        <Lock className={classes.icon_box_icon} />
      </Box>
      <Box>
        <Typography variant="h3">Unauthorized</Typography>
      </Box>
      <Box>
        <Typography variant="subtitle1">
          We’re sorry. This resource requires proper authentication. Please
          choose from the options below.
        </Typography>
      </Box>
      <SystemNavigation />
    </>
  );
}
